// =============================================================================
// Copyright   : 2022 semantics GmbH
// Date        : $Date: 2025-01-29 02:44:42 +0100 (Wed, 29 Jan 2025) $
// Author      : Dirk Rothe
// Worker      : $Author: o.powroznik $
// Revision    : $Rev: 149599 $
// Purpose     : debug support
// =============================================================================

// ---Third-party imports
import React from 'react'
import {Menu} from 'semantic-ui-react'

// ---Framework imports
import {size} from 'ldash'
import {Sel} from 'uix/registries'
import {useSelector} from 'uix/hooks'
import log from 'uix/logging'

// ---Local imports
import {applyProps} from './utils'

// ---Exports
export const DebugFeature = ({children, ...props}) => {
  /* render children if root.debug.on
   */
  let isDebugOn = useSelector(Sel.isDebugOn)
  if (!isDebugOn) {
    return null
  }
  // a DebugFeature in a XMenu needs props pass through
  return size(props) ? applyProps(children, props) : children
}

DebugFeature.displayName = 'DebugFeature'
